import React from 'react'
import moment from 'moment'
import cn from 'classnames'
import { getPewScoreStatus } from 'helpers/environmentMonitor'

function PewList(props) {
  const { forecastData } = props

  return (
    <ul className="forecast-list">
      {forecastData.toJS().map((item, key) => (
        <li
          key={item.time}
          onMouseEnter={() => props.onHover(key)}
          className={cn(`forecast-item pew-${getPewScoreStatus(item.score)}`)}>
          <span className="item-box">
            <div className="item-data">{item.score}%</div>
          </span>
          <span className="item-text">{moment(item.time).format('HH:mm')}</span>
        </li>
      ))}
    </ul>
  )
}

export default PewList
